

























































































































import {Component, Prop, Watch} from "vue-property-decorator";
import bus from "@/main";
import {Api} from "@/core/services/MedicaPro/Api";
import {Measurement} from "@/core/services/MedicaPro/models";
import BaseComponent from "@/core/components/BaseComponent";
import {DateHelper} from "@/helpers/DateHelper";

@Component({
    components: {}
})
export default class MeasurementItemEdit extends BaseComponent {

    // Bindings to parent
    @Prop() item?: Measurement | null;

    // Bindings to view
    public dialog = false;
    public valid = false;
    public rules = {
        name: [(v: any) => !!v || 'Name is required'],
    }
    public name = '';
    public dateDialog = false;
    public dateValue = '';
    public timeDialog = false;
    public timeValue = '';

    public mounted() {
        this.loadItem();
    }

    public save() {
        // Set date
        const date = new Date(this.dateValue);
        const time = this.timeValue.split(':');
        date.setHours(Number(time[0]), Number(time[1]));
        this.item!.date = DateHelper.ServerDate(date);

        if (this.valid) {
            const API = this.item?.exists() ? Api.measurements().patchById(this.item.id!) : Api.measurements().post();
            API.save(this.item!, item => {
                this.close();
                this.$toast(`Måling gemt`, {
                    color: 'green',
                    dismissable: true
                });
                bus.$emit('measurementSaved', item);
            });
        }
    }

    public close() {
        this.dialog = false;
        this.isReady = false;
    }

    @Watch('item')
    private loadItem() {
        if (this.item == null) {
            // Ignore
        } else {
            this.renderView();
            this.dialog = true;
        }
    }

    private renderView() {
        this.name = this.item?.measurement_type_identifier ?? '';
        const date = this.item?.date ? this.item.date : DateHelper.ServerDate(new Date());
        this.dateValue = date.substr(0, 10);
        this.timeValue = date.substr(11, 5);
        this.isReady = true;
    }

}
